export enum DefaultAnyconnectNodeDisplay {
  x1 = -70,
  y1 = 20,
}
